import React, { useState, useCallback } from "react";
import { Form } from "antd";
import { Table } from "ant-table-extensions";
import FeatherIcon from "feather-icons-react";
import { UserTableStyleWrapper } from "../../pages/style";
import { TableWrapper } from "../../styled";

import { Button } from "../../../components/buttons/buttons";
import { Cards } from "../../../components/cards/frame/cards-frame";

import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { formatPrice, formatSQLDate } from "../../../utils/common";

import { useMutation, useLazyQuery } from "@apollo/client";
import { DELETE_SERVICE_ACTION } from "../../../graphql/AdminMutations";
import { GET_SERVICE_ACTIONS } from "../../../graphql/AdminQueries";

import { deleteServiceAction } from "../../../redux/services/actionCreator";
import displayNotification from "../../reservation/admin/notification/notification";
import { exportujDoExcelu, odkazNaAdmin } from "../../../utils/exportExcel";
import { klikNaRiadok } from "../../../utils/klikNaRiadok";

import { useHistory } from "react-router-dom";

// import { ModalForm } from './tabs/modalForm'

const List = (props) => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();
  const {
    inputData,
    graphqlVariables,
    checkedStatus,
    total,
    sendPageNumberToGrid,
    pageNumberToGrid,
    downloadCsvStatus,
    buttons,
    limit,
  } = props;
  const displayExportPdf = checkedStatus === "open" ? true : false;
  const [form] = Form.useForm();

  const [state, setState] = useState({
    editVisible: false,
    update: {},
    newIncomeModalState: false,
  });

  // delete service action
  const [triggerDeleteItem] = useMutation(DELETE_SERVICE_ACTION, {
    variables: graphqlVariables,
  });

  const history = useHistory();

  const routeChange = (item) => {
    const detailPath = `/admin/service/action/${item.id}`;
    history.push(detailPath);
  };

  const [formReadonly, setFormReadonly] = useState(true);
  const [selectedItem, setSelectedItem] = useState({});
  const [
    fetchAllServiceActions,
    { loading: exportLoading },
  ] = useLazyQuery(GET_SERVICE_ACTIONS, { fetchPolicy: "network-only" });

  const tableData = [];
  const modalData = [];
  console.log("inputData", inputData);
  if (Array.isArray(inputData)) {
    inputData.forEach((item) => {
      const {
        id,
        branchOffice,
        car,
        carOwner,
        date,
        status,
        total,
        invoice_number,
        exportBlDate,
        exportBlStatus,
        downloadCsvStatus,
        ayvens_contract_number,
      } = item;
      const deleteDisabled = invoice_number ? true : false;
      const link = "/admin/car/edit/" + car?.id;
      const serviceDetailLink = "/admin/service/action/" + id;
      let invoiceNumber = invoice_number;
      if (exportBlStatus === true) {
        invoiceNumber = (
          <ul>
            <span>{invoice_number}</span>
            <p>{formatSQLDate(exportBlDate)}</p>
          </ul>
        );
      }
      tableData.push({
        key: id,
        id: (
          <a key={id} href={serviceDetailLink}>
            <span className={`status-text`}>{id}</span>
          </a>
        ),
        licence_plate: (
          <a key={id} href={link}>
            <span className={`status-text`}>{car?.licence_plate}</span>
          </a>
        ),
        date: formatSQLDate(date),
        status: t("serviceActions.tableList.statuses." + status),
        owner: carOwner?.company,
        branchOffice: branchOffice?.company,
        total: formatPrice(total),
        invoiceNumber: invoiceNumber,
        zaznam: item,
        action: (
          <div className="table-actions" onClick={(e) => e.stopPropagation()}>
            <>
              <Button
                onClick={() => routeChange(item)}
                className="btn-icon"
                type="info"
                to="#"
                shape="circle"
              >
                <FeatherIcon icon="edit" size={16} />
              </Button>
              <Button
                onClick={() => deleteItem(item, "delete")}
                className="btn-icon"
                type="info"
                to="#"
                shape="circle"
                disabled={deleteDisabled}
              >
                <FeatherIcon icon="trash-2" size={16} />
              </Button>
            </>
          </div>
        ),
      });
    });
  }

  const deleteItem = (data) => {
    const id = Number(data.id);
    const confirm = window.confirm(t("serviceActions.tableList.delete"));
    if (confirm) {
      const variables = {
        ...graphqlVariables,
        id: id,
      };
      triggerDeleteItem({ variables }).then(({ data }) => {
        const response = data?.deleteServiceAction;
        let type = "success";
        const message = t("backend.notifications.update");
        let desc = t("backend.notifications.success.recordDelete");
        if (response.sucessful) {
          dispatch(deleteServiceAction(id));
        } else {
          type = "error";
          desc = t("backend.notifications.error.recordDelete");
        }
        displayNotification(type, message, desc);
      });
    }
  };

  const STLPCE_EXPORTU = [
    { kluc: "cislo", popis: "Č. zákazky", sirka: 14, typ: "odkaz" },
    { kluc: "ecv", popis: "EČV", sirka: 14, typ: "odkaz" },
    { kluc: "vozidlo", popis: "Vozidlo", sirka: 28 },
    { kluc: "stav", popis: "Stav", sirka: 16 },
    { kluc: "datum", popis: "Dátum", sirka: 12, typ: "datum" },
    { kluc: "majitel", popis: "Majiteľ", sirka: 30 },
    { kluc: "pneuservis", popis: "Pneuservis", sirka: 20 },
    { kluc: "spolu", popis: "Spolu", sirka: 14, typ: "penize" },
    { kluc: "faktura", popis: "Číslo faktúry", sirka: 16 },
  ];

  const handleDownload = async () => {
    try {
      // Export berie presne to, co je v zozname vyfiltrovane, len bez
      // stranovania. Predtym ignoroval filtre aj hladany text.
      const variables = {
        ...(props.premenneDoExportu || {}),
        tokenGet: graphqlVariables?.tokenGet,
        status: checkedStatus || undefined,
        offset: 0,
        limit: 0,
      };
      const { data } = await fetchAllServiceActions({ variables });
      const records = data?.getServiceActions?.records || [];
      await exportujDoExcelu({
        nazovSuboru: "zakazky",
        nazovHarku: "Zákazky",
        stlpce: STLPCE_EXPORTU,
        riadky: records.map((z) => ({
          cislo: {
            text: z?.id || "",
            url: odkazNaAdmin(`/admin/service/action/${z?.id}`),
          },
          ecv: {
            text: z?.car?.licence_plate || "",
            url: z?.car?.id ? odkazNaAdmin(`/admin/car/edit/${z.car.id}`) : null,
          },
          vozidlo: z?.car?.type,
          stav: t("serviceActions.tableList.statuses." + z?.status),
          datum: z?.date,
          majitel: z?.carOwner?.company,
          pneuservis: z?.branchOffice?.company,
          spolu: z?.total,
          faktura: z?.invoice_number,
        })),
        info: {
          Stav: checkedStatus || "všetky",
          "Hľadaný text": props.premenneDoExportu?.search || "",
        },
      });
    } catch (e) {
      console.error("Export failed", e);
    } finally {
    }
  };
  const defaultPageSize = limit;

  return (
    <Cards headless>
      <UserTableStyleWrapper>
        {/* {displayExportPdf && displayExportPdf === true && <Button>1111</Button>} */}
        <Button
          className="btn-export"
          onClick={handleDownload}
          type="primary"
          disabled={exportLoading}
        >
          {exportLoading ? "Pripravujem export..." : "Export do Excelu"}
        </Button>
        {buttons}

        <TableWrapper className="table-responsive">
          <Table
            scroll={{ x: "max-content" }}
            dataSource={tableData}
            loading={props.loading}
            rowClassName={() => "riadok-klikatelny"}
            onRow={(record) =>
              klikNaRiadok({
                cesta: `/admin/service/action/${record?.zaznam?.id}`,
                akcia: () => record?.zaznam && routeChange(record.zaznam),
              })
            }
            columns={getTableColumns(t)}
            pagination={{
              defaultPageSize: defaultPageSize,
              total: total,
              showTotal: (total, range) =>
                `${range[0]}-${range[1]} ${t("common.from")} ${total} ${t(
                  "common.items"
                )}`,
              position: ["topLeft", "bottomLeft"],
              onChange: sendPageNumberToGrid,
              current: pageNumberToGrid || 1,
            }}
            onChange={(pagination) => {
              console.log("Selected Row:", pagination);
              const data = {
                pageNumber: pagination.current,
                pageSize: pagination.pageSize,
              };
              sendPageNumberToGrid(data);
            }}
          />
        </TableWrapper>
      </UserTableStyleWrapper>
    </Cards>
  );
};

const getTableColumns = (t) => {
  return [
    {
      title: t("serviceActions.tableList.licencePlate"),
      dataIndex: "licence_plate",
      key: "licence_plate",
    },
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
    },
    {
      title: t("serviceActions.tableList.status"),
      dataIndex: "status",
      key: "status",
    },
    {
      title: t("serviceActions.tableList.date"),
      dataIndex: "date",
      key: "date",
    },
    {
      title: t("serviceActions.tableList.carOwner"),
      dataIndex: "owner",
      key: "owner",
    },
    {
      title: t("serviceActions.tableList.branchOffice"),
      dataIndex: "branchOffice",
      key: "branchOffice",
    },
    {
      title: t("serviceActions.tableList.total"),
      dataIndex: "total",
      key: "total",
    },
    {
      title: t("serviceActions.tableList.invoiceNumber"),
      dataIndex: "invoiceNumber",
      key: "invoiceNumber",
    },
    {
      title: t("common.actions"),
      dataIndex: "action",
      key: "action",
      width: "90px",
    },
  ];
};

export default List;
